import iro from "@jaames/iro";

const config = {
	queryDict: true, // to store GET parameters
	testCurves: {
		enabled: false,
		smartCurve: true, // Whether or not we should display the curves in test container
	},
	IDT_ODT_combinations: [
		{
			IDT: "",
			ODT: "ODT_sRGB_100nits_dim",
		},
		{
			IDT: "Bypass",
			ODT: "Bypass",
		},
		// {
		//   IDT: 'IDT_sRGB',
		//   ODT: 'ODT_sRGB_100nits_dim',
		// },
	],
	IDT: [
		{ value: "IDT100", name: "Bypass", label: "No Input Transform", exportName: "No Input Transform" },
		{ value: "IDT100_ACES", name: "ACES", label: "ACES2065-1", exportName: "ACES2065-1" },
		{ value: 'IDT101', name: 'ACEScc_to_ACES', label: 'ACEScc', exportName: 'ACEScc' },
		{ value: 'IDT102', name: 'ACEScct_to_ACES', label: 'ACEScct', exportName: 'ACEScct' },
		{ value: 'IDT103', name: 'ACEScg_to_ACES', label: 'ACEScg', exportName: "ACEScg" },
		{ value: "IDT104", name: "ADX10_to_ACES", label: "ADX10", exportName: "ADX10" },
		// { value: "IDT105", name: "IDT_rec709", label: "Rec709" },
		// { value: "IDT106", name: "IDT_sRGB", label: "sRGB" },
		{ value: "IDT107", name: "IDT_Alexa_v3_logC_EI800", label: "Arri Alexa - LogC3", exportName: "LogC3" },
		//{ value: 'IDT108', name: 'IDT_Alexa_v3_raw_EI800_CCT6500', label: 'Arri Alexa Raw EI800 6500K' },
		{ value: "IDT109", name: "IDT_Panasonic_V35", label: "Panasonic V-Gamut V-Log", exportName: "VLog" },
		{ value: "IDT110", name: "IDT_REDWideGamutRGB_Log3G10", label: "RED REDWideGamutRGB Log3G10", exportName: "RWG" },
		//{ value: "IDT111", name: "IDT_Canon_C100_A_D55", label: "Canon C100 D55" },
		//{ value: "IDT112", name: "IDT_Canon_C100_A_Tng", label: "Canon C100 Tungsten" },
		//{ value: "IDT113", name: "IDT_Canon_C100mk2_A_D55", label: "Canon C100 MKII D55" },
		//{ value: "IDT114", name: "IDT_Canon_C100mk2_A_Tng", label: "Canon C100 MKII Tungsten" },
		//{ value: "IDT115", name: "IDT_Canon_C300_A_D55", label: "Canon C300 D55" },
		//{ value: "IDT116", name: "IDT_Canon_C300_A_Tng", label: "Canon C300 Tungsten" },
		//{ value: "IDT117", name: "IDT_Canon_C500_A_D55", label: "Canon C500 A D55" },
		//{ value: "IDT118", name: "IDT_Canon_C500_A_Tng", label: "Canon C500 A Tungsten" },
		//{ value: "IDT119", name: "IDT_Canon_C500_B_D55", label: "Canon C500 B D55" },
		//{ value: "IDT120", name: "IDT_Canon_C500_B_Tng", label: "Canon C500 B Tungsten" },
		//{ value: "IDT121", name: "IDT_Canon_C500_CinemaGamut_A_D55", label: "Canon C500 Cinema Gamut D55" },
		//{ value: "IDT122", name: "IDT_Canon_C500_CinemaGamut_A_Tng", label: "Canon C500 Cinema Gamut Tungsten" },
		//{ value: "IDT123", name: "IDT_Canon_C500_DCI_P3_A_D55", label: "Canon C500 DCI-P3 D55" },
		//{ value: "IDT124", name: "IDT_Canon_C500_DCI_P3_A_Tng", label: "Canon C500 DCI-P3 Tungsten" },
		{ value: "IDT125", name: "IDT_Canon_C300mk2_CanonLog_BT2020_D_D55", label: "CanonLog BT2020 Daylight", exportName: "CanonLogBT2020" },
		{ value: "IDT126", name: "IDT_Canon_C300mk2_CanonLog_BT2020_D_Tng", label: "CanonLog BT2020 Tungsten", exportName: "CanonLogBT2020" },
		{ value: "IDT127", name: "IDT_Canon_C300mk2_CanonLog_CinemaGamut_C_D55", label: "CanonLog Cinema Gamut Daylight", exportName: "CanonLog" },
		{ value: "IDT128", name: "IDT_Canon_C300mk2_CanonLog_CinemaGamut_C_Tng", label: "CanonLog Cinema Gamut Tungsten", exportName: "CanonLog" },
		{ value: "IDT129", name: "IDT_Canon_C300mk2_CanonLog2_BT2020_B_D55", label: "CanonLog2 BT2020 Daylight", exportName: "CanonLog2BT2020" },
		{ value: "IDT130", name: "IDT_Canon_C300mk2_CanonLog2_BT2020_B_Tng", label: "CanonLog2 BT2020 Tungsten", exportName: "CanonLog2BT2020" },
		{ value: "IDT131", name: "IDT_Canon_C300mk2_CanonLog2_CinemaGamut_A_D55", label: "CanonLog2 Cinema Gamut Daylight", exportName: "CanonLog2" },
		{ value: "IDT132", name: "IDT_Canon_C300mk2_CanonLog2_CinemaGamut_A_Tng", label: "CanonLog2 Cinema Gamut Tungsten", exportName: "CanonLog2" },
		{ value: "IDT133", name: "IDT_Canon_C300mk2_CanonLog3_BT2020_F_D55", label: "CanonLog3 BT2020 Daylight", exportName: "CanonLog3BT2020" },
		{ value: "IDT134", name: "IDT_Canon_C300mk2_CanonLog3_BT2020_F_Tng", label: "CanonLog3 BT2020 Tungsten", exportName: "CanonLog3BT2020" },
		{ value: "IDT135", name: "IDT_Canon_C300mk2_CanonLog3_CinemaGamut_E_D55", label: "CanonLog3 Cinema Gamut Daylight", exportName: "CanonLog3" },
		{ value: "IDT136", name: "IDT_Canon_C300mk2_CanonLog3_CinemaGamut_E_Tng", label: "CanonLog3 Cinema Gamut Tungsten", exportName: "CanonLog3" },
		{ value: "IDT137", name: "IDT_Sony_SLog1_SGamut_10", label: "Sony S-Log S-Gamut 10-bit", exportName: "SLog" },
		{ value: "IDT138", name: "IDT_Sony_SLog1_SGamut_12", label: "Sony S-Log S-Gamut 12-bit", exportName: "SLog"  },
		{ value: "IDT139", name: "IDT_Sony_SLog2_SGamut_Daylight_10", label: "Sony S-Log2 S-Gamut Daylight 10-bit", exportName: "SLog2" },
		{ value: "IDT140", name: "IDT_Sony_SLog2_SGamut_Daylight_12", label: "Sony S-Log2 S-Gamut Daylight 12-bit", exportName: "SLog2" },
		{ value: "IDT141", name: "IDT_Sony_SLog2_SGamut_Tungsten_10", label: "Sony S-Log2 S-Gamut Tungsten 10-bit", exportName: "SLog2" },
		{ value: "IDT142", name: "IDT_Sony_SLog2_SGamut_Tungsten_12", label: "Sony S-Log2 S-Gamut Tungsten 12-bit", exportName: "SLog2" },
		{ value: "IDT143", name: "IDT_Sony_SLog3_SGamut3", label: "Sony S-Log3 S-Gamut3", exportName: "SLog3SGamut3" },
		{ value: "IDT144", name: "IDT_Sony_SLog3_SGamut3Cine", label: "Sony S-Log3 S-Gamut3.Cine", exportName: "SLog3SGamut3Cine" },
		{ value: "IDT145", name: "IDT_Sony_Venice_SLog3_SGamut3", label: "Sony Venice S-Log3 S-Gamut3", exportName: "SLog3SGamut3Venice" },
		{ value: "IDT146", name: "IDT_Sony_Venice_SLog3_SGamut3Cine", label: "Sony Venice S-Log3 S-Gamut3.Cine", exportName: "SLog3SGamut3CineVenice" },
		{ value: "IDT147", name: "ADX16_to_ACES", label: "ADX16", exportName: "ADX16" },
		{ value: "IDT148", name: "IDT_RED_DragonColor_REDLogFilm", label: "RED DragonColor REDLogFilm", exportName: "RLFDragonColor" },
		{ value: "IDT149", name: "IDT_RED_DragonColor2_REDLogFilm", label: "RED DragonColor2 REDLogFilm", exportName: "RLFDragonColor2" },
		{ value: "IDT150", name: "IDT_RED_REDColor_REDLogFilm", label: "RED REDColor REDLogFilm", exportName: "RLFRedColor" },
		{ value: "IDT151", name: "IDT_RED_REDColor2_REDLogFilm", label: "RED REDColor2 REDLogFilm", exportName: "RLFRedColor2" },
		{ value: "IDT152", name: "IDT_RED_REDColor3_REDLogFilm", label: "RED REDColor3 REDLogFilm", exportName: "RLFRedColor3" },
		{ value: "IDT153", name: "IDT_RED_REDColor4_REDLogFilm", label: "RED REDColor4 REDLogFilm", exportName: "RLFRedColor4" },
		{ value: "IDT154", name: "IDT_DJI_DGamut_DLog", label: "DJI D-Gamut D-Log", exportName: "DJIDLog" },
		{ value: "IDT155", name: "IDT_Fujifilm_FGamut_FLog", label: "Fujifilm F-Gamut F-Log", exportName: "FLog" },
		{ value: "IDT156", name: "IDT_BolexWideGamut_BolexLog", label: "Bolex Wide Gamut RGB Bolex Log", exportName: "BolexLog" },
		{ value: "IDT157", name: "IDT_Nikon_BT2020_NLog", label: "Nikon BT2020 N-Log", exportName: "NikonLog" },
		{ value: "IDT158", name: "IDT_GoPro_ProTune_Flat", label: "GoPro ProTune Native ProTune Flat", exportName: "ProTune" },
		{ value: 'IDT159', name: 'IDT_ZCam_ZLog2', label: 'Z-Cam Z-Log2 - BETA', exportName: "ZLog2", hidden: true },
		{ value: 'IDT160', name: 'IDT_Kinefinity_KineLog3', label: 'Kinefinity KineLOG3 - BETA', exportName: "KineLog3" },
		{ value: 'IDT161', name: 'IDT_AdobeRGB', label: 'Adobe RGB', exportName: "AdobeRGB" },
		{ value: 'IDT162', name: 'IDT_ProPhotoRGB', label: 'ProPhoto RGB', exportName: "ProPhotoRGB" },
		{ value: 'IDT163', name: 'IDT_sRGBNonInverse', label: 'sRGB - Raw', exportName: "sRGBRaw" },
		{ value: 'IDT164', name: 'IDT_Alexa_v4_logC', label: 'Arri Alexa 35 - LogC4', exportName: "LogC4" },
		{ value: 'IDT165', name: 'IDT_Fujifilm_FGamut_FLog2', label: 'Fujifilm F-Gamut F-Log2', exportName: "FLog2" },
		{ value: 'IDT166', name: 'IDT_BMDFilmGen5', label: 'BMD Wide Gamut BMDFilm Gen 5', exportName: "BMDGen5" },
		{ value: 'IDT167', name: 'IDT_Leica_BT2020_LLog', label: 'Leica BT2020 L-Log', exportName: "LeicaLog" },
		{ value: 'IDT168', name: 'IDT_AppleLog', label: 'Apple Log', exportName: "AppleLog" },
		{ value: 'IDT169', name: 'P3 D60', label: 'P3 D60', exportName: "P3D60" },
		{ value: 'IDT170', name: 'P3 D65', label: 'P3 D65', exportName: "P3D65" },
		// { value: 'IDT171', name: 'P3D65_D60sim', label: 'P3D65_D60sim', exportName: "P3D65_D60sim" },
        { value: "IDT172", name: "IDT_DaVinci_DWG", label: "DaVinci Wide Gamut Intermediate", exportName: "DaVinci Wide Gamut Intermediate" },
        { value: "IDT173", name: "IDT_FLog2C", label: "Fujifilm F-GamutC F-Log2C", exportName: "Fujifilm F-GamutC F-Log2C" },
        { value: "IDT174", name: "IDT_ZCAM_ZLog2", label: "ZCAM Z-Log2", exportName: "ZCAM Z-Log2" },
        { value: "IDT175", name: "IDT_Phantom_Log_2", label: "Phantom Log 2", exportName: "Phantom Log 2" },
        { value: "IDT176", name: "IDT_Phantom_Log_1", label: "Phantom Log 1", exportName: "Phantom Log 1" },

		// LUT BASED IDTs
		{ value: "LIDT101", name: "BMD Wide Gamut BMDFilm Pocket 4K EI400", label: "BMD Wide Gamut BMDFilm Pocket 4K EI400", type: "LUT", exportName: "BMDPC4KEI400" },
		{ value: "LIDT102", name: "BMD Wide Gamut BMDFilm Pocket 4K EI3200", label: "BMD Wide Gamut BMDFilm Pocket 4K EI3200", type: "LUT", exportName: "BMDPC4KEI3200" },
		{ value: "LIDT103", name: "BMD Wide Gamut BMDFilm", label: "BMD Wide Gamut BMDFilm Gen 4", type: "LUT", exportName: "BMDGen4" },
		{ value: "LIDT104", name: "BMDFilm 4K Gamut BMDFilm 4K", label: "BMDFilm 4K Gamut BMDFilm 4K - Legacy", type: "LUT", exportName: "BMDFilm4K" },
		{ value: "LIDT105", name: "BMDFilm 4K V3 Gamut BMDFilm 4K", label: "BMDFilm 4K V3 Gamut BMDFilm 4K - Legacy", type: "LUT", exportName: "BMDFilm4KV3" },
		{ value: "LIDT106", name: "BMDFilm 46K Gamut BMDFilm 46K", label: "BMDFilm 4.6K Gamut BMDFilm 4.6K - Legacy", type: "LUT", exportName: "BMDFilm46K" },
		{ value: "LIDT107", name: "BMDFilm 46K V3 Gamut BMDFilm 46K", label: "BMDFilm 4.6K V3 Gamut BMDFilm 4.6K - Legacy", type: "LUT", exportName: "BMDFilm46KV3" },
		{ value: "LIDT108", name: "BMDFilm Gamut BMDFilm", label: "BMDFilm Gamut BMDFilm - Legacy", type: "LUT", exportName: "BMDFilm" },
		{ value: "LIDT109", name: "Rec709-IDT-33", label: "Rec709", type: "LUT", exportName: "Rec709" },
		{ value: "LIDT110", name: "sRGB-IDT-33", label: "sRGB", type: "LUT", exportName: "sRGB" },
		//{ value: "LIDT111", name: "AdobeRGB-IDT", label: "Adobe RGB", type: "LUT" },
		//{ value: "LIDT112", name: "ProPhotoRGB-IDT", label: "ProPhoto RGB", type: "LUT" },
		{ value: "LIDT113", name: "iPhone-12-Pro-Dolby-Vision-IDT", label: "iPhone Pro Dolby Vision", type: "LUT", exportName: "iPhoneDolbyVision" },
		//{ value: 'LIDT109', name: 'Bolex Wide Gamut RGB Bolex Log', label: 'Bolex Wide Gamut RGB Bolex Log', type: 'LUT' },
		//{ value: 'LIDT110', name: 'DJI D-Gamut D-Log', label: 'DJI D-Gamut D-Log', type: 'LUT' },
		//{ value: 'LIDT111', name: 'Fujifilm F-Gamut F-Log', label: 'Fujifilm F-Gamut F-Log', type: 'LUT' },
		//{ value: 'LIDT112', name: 'GoPro ProTune Native ProTune Flat', label: 'GoPro ProTune Native ProTune Flat', type: 'LUT' },
		//{ value: 'LIDT113', name: 'Nikon BT2020 N-Log', label: 'Nikon BT2020 N-Log', type: 'LUT' },
		//{ value: 'LIDT114', name: 'RED DragonColor REDLogFilm', label: 'RED DragonColor REDLogFilm', type: 'LUT' },
		//{ value: 'LIDT115', name: 'RED DragonColor2 REDLogFilm', label: 'RED DragonColor2 REDLogFilm', type: 'LUT' },
		//{ value: 'LIDT116', name: 'RED REDColor REDLogFilm', label: 'RED REDColor REDLogFilm', type: 'LUT' },
		//{ value: 'LIDT117', name: 'RED REDColor2 REDLogFilm', label: 'RED REDColor2 REDLogFilm', type: 'LUT' },
		//{ value: 'LIDT118', name: 'RED REDColor3 REDLogFilm', label: 'RED REDColor3 REDLogFilm', type: 'LUT' },
		//{ value: 'LIDT119', name: 'RED REDColor4 REDLogFilm', label: 'RED REDColor4 REDLogFilm', type: 'LUT' },
		{ value: 'LIDT120', name: 'IDT Inverse DisplayP3 Gamma 2.2', label: 'DisplayP3 Gamma 2.2 ACES 2.0', type: 'LUT' },
		{ value: 'LIDT121', name: 'IDT Inverse DisplayP3', label: 'DisplayP3 ACES 2.0', type: 'LUT' },
		{ value: 'LIDT122', name: 'IDT Inverse Extended DisplayP3 1000 nit', label: 'Extended DisplayP3 1000 nit ACES 2.0', type: 'LUT' },
		{ value: 'LIDT123', name: 'IDT Inverse P3D65 (Rec709 Limited)', label: 'P3 D65 (Rec709 Limited) ACES 2.0', type: 'LUT' },
		{ value: 'LIDT124', name: 'IDT Inverse P3D65 ST2084 108 nit', label: 'P3 D65 ST2084 108 nit ACES 2.0', type: 'LUT' },
		{ value: 'LIDT125', name: 'IDT Inverse P3D65 ST2084 500 nit', label: 'P3 D65 ST2084 500 nit ACES 2.0', type: 'LUT' },
		{ value: 'LIDT126', name: 'IDT Inverse P3D65 ST2084 1000 nit', label: 'P3 D65 ST2084 1000 nit ACES 2.0', type: 'LUT' },
		{ value: 'LIDT127', name: 'IDT Inverse P3D65', label: 'P3 D65 ACES 2.0', type: 'LUT' },
		{ value: 'LIDT128', name: 'IDT Inverse Rec709', label: 'Rec709 ACES 2.0', type: 'LUT' },
		{ value: 'LIDT129', name: 'IDT Inverse Rec2100 HLG (1000 nit P3D65 Limited)', label: 'Rec2100 HLG (1000 nit P3 D65 Limited) ACES 2.0', type: 'LUT' },
		{ value: 'LIDT130', name: 'IDT Inverse Rec2100 ST2084 500 nit', label: 'Rec2100 St2084 500 nit ACES 2.0', type: 'LUT' },
		{ value: 'LIDT131', name: 'IDT Inverse Rec2100 ST2084 1000 nit', label: 'Rec2100 St2084 1000 nit ACES 2.0', type: 'LUT' },
		{ value: 'LIDT132', name: 'IDT Inverse sRGB Gamma 2.2', label: 'sRGB ACES 2.0', type: 'LUT' },
	],
	ODT: [
		{ value: "ODT400", name: "Bypass", label: "No Output Transform", exportName: "No Output Transform" },
		//{ value: 'ODT401', name: 'ACES_to_ACEScc', label: 'ACES to ACEScc' },
		//{ value: 'ODT402', name: 'ACES_to_ACEScct', label: 'ACES to ACEScct' },
		// { value: 'ODT403', name: 'ACES_to_ACEScg', label: 'ACEScg', exportName: "ACEScg" },
		{ value: "ODT404", name: "ODT_Rec709_100nits_dim", label: "Rec709", exportName: "Rec709" },
		{ value: "ODT405", name: "ODT_Rec709_D60sim_100nits_dim", label: "Rec709 (D60 Simulated)", exportName: "Rec709D60Sim" },
		{ value: "ODT406", name: "ODT_Rec2020_100nits_dim", label: "Rec2020", exportName: "Rec2020" },
		// { value: 'ODT407', name: 'ODT_Rec2020_ST2084_1000nits', label: 'Rec2020 ST2084 1000 nits' },
		{ value: "ODT408", name: "ODT_Rec2020_Rec709limited_100nits_dim", label: "Rec2020 (Rec709 Limited)", exportName: "Rec2020Rec709Lim" },
		{ value: "ODT409", name: "ODT_Rec2020_P3D65limited_100nits_dim", label: "Rec2020 (P3 D65 Limited)", exportName: "Rec2020P3D65Lim" },
		{ value: "ODT410", name: "ODT_sRGB_100nits_dim", label: "sRGB", exportName: "sRGB" },
		{ value: "ODT411", name: "ODT_sRGB_D60sim_100nits_dim", label: "sRGB (D60 Simulated)", exportName: "sRGBD60Sim" },
		{ value: "ODT412", name: "ODT_P3DCI_48nits", label: "P3 DCI", exportName: "P3DCI" },
		{ value: "ODT413", name: "ODT_P3DCI_D60sim_48nits", label: "P3 DCI (D60 Simulated)", exportName: "P3DCID60Sim" },
		{ value: "ODT414", name: "ODT_P3DCI_D65sim_48nits", label: "P3 DCI (D65 Simulated)", exportName: "P3DCID65Sim" },
		{ value: "ODT415", name: "ODT_P3D60_48nits", label: "P3 D60", exportName: "P3D60" },
		{ value: "ODT416", name: "ODT_P3D65_48nits", label: "P3 D65", exportName: "P3D65" },
		{ value: "ODT417", name: "ODT_P3D65_D60sim_48nits", label: "P3 D65 (D60 Simulated)", exportName: "P3D65D60Sim" },
		{ value: "ODT418", name: "ODT_P3D65_Rec709limited_48nits", label: "P3 D65 (Rec709 Limited)", exportName: "P3D65Rec709Lim" },
		{ value: "ODT419", name: "ODT_DCDM", label: "DCDM", exportName: "DCDM" },
		{ value: "ODT420", name: "ODT_DCDM_P3D60limited", label: "DCDM (P3 D60 Limited)", exportName: "DCDMP3D60" },
		{ value: "ODT421", name: "ODT_DCDM_P3D65limited", label: "DCDM (P3 D65 Limited)", exportName: "DCDMP3D65" },
		//{ value: 'ODT422', name: 'ODT_RGBmonitor_100nits_dim', label: 'RGB Monitor' },
		//{ value: 'ODT423', name: 'ODT_RGBmonitor_D60sim_100nits_dim', label: 'RGB Monitor (D60 Simulated)' },

		// RRTODT
		{ value: "RRTODT701", name: "P3 D65 ST2084 108 nits", label: "P3 D65 ST2084 108 nits", type: "RRTODT", exportName: "P3D65PQ108nits" },
		{ value: "RRTODT702", name: "Rec2020 HLG 1000 nits", label: "Rec2020 HLG 1000 nits", type: "RRTODT", exportName: "Rec2020HLG100nits" },
		{ value: "RRTODT703", name: "Rec2020 ST2084 1000 nits", label: "Rec2020 ST2084 1000 nits", type: "RRTODT", exportName: "Rec2020PQ1000nits" },
		{ value: "RRTODT704", name: "Rec2020 ST2084 2000 nits", label: "Rec2020 ST2084 2000 nits", type: "RRTODT", exportName: "Rec2020PQ2000nits" },
		{ value: "RRTODT705", name: "Rec2020 ST2084 4000 nits", label: "Rec2020 ST2084 4000 nits", type: "RRTODT", exportName: "Rec2020PQ4000nits" },
		{ value: "RRTODT709", name: "P3 D65 ST2084 1000 nits", label: "P3 D65 ST2084 1000 nits", type: "RRTODT", exportName: "P3D65PQ1000nits" },

		// LUT BASED ODTs
		{ value: 'LODT101', name: 'ODT DisplayP3 Gamma 2.2', label: 'DisplayP3 Gamma 2.2 ACES 2.0', type: 'LUT' },
		{ value: 'LODT102', name: 'ODT DisplayP3', label: 'DisplayP3 ACES 2.0', type: 'LUT' },
		{ value: 'LODT103', name: 'ODT Extended DisplayP3 1000 nit', label: 'Extended DisplayP3 1000 nit ACES 2.0', type: 'LUT' },
		{ value: 'LODT104', name: 'ODT P3D65 (Rec709 Limited)', label: 'P3 D65 (Rec709 Limited) ACES 2.0', type: 'LUT' },
		{ value: 'LODT105', name: 'ODT P3D65 ST2084 108 nit', label: 'P3 D65 ST2084 108 nit ACES 2.0', type: 'LUT' },
		{ value: 'LODT106', name: 'ODT P3D65 ST2084 500 nit', label: 'P3 D65 ST2084 500 nit ACES 2.0', type: 'LUT' },
		{ value: 'LODT107', name: 'ODT P3D65 ST2084 1000 nit', label: 'P3 D65 ST2084 1000 nit ACES 2.0', type: 'LUT' },
		{ value: 'LODT108', name: 'ODT P3D65', label: 'P3 D65 ACES 2.0', type: 'LUT' },
		{ value: 'LODT109', name: 'ODT Rec709', label: 'Rec709 ACES 2.0', type: 'LUT' },
		{ value: 'LODT110', name: 'ODT Rec2100 HLG (1000 nit P3D65 Limited)', label: 'Rec2100 HLG (1000 nit P3 D65 Limited) ACES 2.0', type: 'LUT' },
		{ value: 'LODT111', name: 'ODT Rec2100 ST2084 500 nit', label: 'Rec2100 St2084 500 nit ACES 2.0', type: 'LUT' },
		{ value: 'LODT112', name: 'ODT Rec2100 ST2084 1000 nit', label: 'Rec2100 St2084 1000 nit ACES 2.0', type: 'LUT' },
		{ value: 'LODT113', name: 'ODT sRGB Gamma 2.2', label: 'sRGB ACES 2.0', type: 'LUT' },
	],
	blocks: [
		{
			type: "AIControls",
			label: "AI Controls",
			controls: [
				{
					name: "NeuralToneAI",
					icon: "ambient_screen",
					iconClass: "material-symbols-outlined",
					label: "NeuralToneAI",
					showNewLabel: true,
				},
				{
					name: "NeuralFilmAI",
					icon: "photo_filter",
					iconClass: "material-symbols-outlined",
					label: "NeuralFilmAI",
					showNewLabel: true,
				},
				{
					name: "AIMagicMode",
					icon: "",
					iconClass: "fas fa-magic",
					iconSize: 16,
					label: "Magic Mode",
				},
				{
					name: "AIAutoCorrectV2",
					icon: "temp_preferences_custom",
					iconClass: "material-symbols-outlined",
					label: "AI Auto Correct",
					showNewLabel: true,
				},
				{
					name: "AIColourMatchV2",
					icon: "auto_activity_zone",
					iconClass: "material-symbols-outlined",
					label: "AI Colour Match",
					showNewLabel: true,
				},
				{
					name: "AIExposure",
					icon: "exposure",
					label: "AI Exposure",
				},
				{
					name: "AIContrast",
					icon: "hdr_strong",
					label: "AI Contrast",
				},
				{
					name: "AIWhiteBalance",
					icon: "wb_sunny",
					label: "AI White Balance",
				},
			]
		},
		{
			type: "legacy-ai-tools",
			label: "AI Tools",
			controls: [
				{
					name: "AIAutoCorrect",
					icon: "temp_preferences_custom",
					iconClass: "material-symbols-outlined",
					label: "Legacy AI Auto Correct",
				},
				{
					name: "AIColourExtractV2",
					icon: "auto_awesome",
					label: "Legacy AI Colour Extract",
				},
				{
					name: "AIColourMatch",
					icon: "auto_activity_zone",
					iconClass: "material-symbols-outlined",
					label: "Legacy AI Colour Match",
				},
			]
		},
		{
			type: "legacy-traditional-tools",
			label: "Traditional Tools",
			controls: [
				{
					name: "customLUT",
					icon: "image_aspect_ratio",
					label: "Legacy Custom 3D LUT",
				},
				{
					name: "colourMatch",
					icon: "filter",
					label: "Legacy Technical Colour Match",
				},
				{
					name: "subtractiveColour",
					icon: "batch_prediction",
					label: "Subtractive Colour",
				},
			]
		},
		{
			type: 'TraditionalControls',
			label: "Traditional Controls",
			controls: [
				{
					name: "TetrahedralInterpolation",
					icon: "details",
					iconClass: "material-icons-outlined",
					label: "Tetrahedral Interpolation",
					showNewLabel: true,
				},
				// {
				// 	name: "LensDistortionEffect",
				// 	icon: "ambient_screen",
				// 	iconClass: "material-symbols-outlined",
				// 	label: "Lens Distortion Effect",
				// 	showNewLabel: true,
				// },
				{
					name: "logPrimaries",
					icon: "adjust",
					label: "Log Primaries",
				},
				// {
				// 	name: "primaries",
				// 	icon: "panorama_fish_eye",
				// 	label: "Primaries",
				// },
				{
					name: "PrimariesV2",
					icon: "panorama_fish_eye",
					label: "Primaries",
				},
				// {
				// 	name: "printerLights",
				// 	icon: "filter_tilt_shift",
				// 	label: "Printer Lights",
				// },
				{
					name: "PrinterLightsV2",
					icon: "filter_tilt_shift",
					label: "Printer Lights",
				},
                {
                    name: "SkinToneEditor",
                    icon: "face_5",
                    label: "Skin Tone Editor",
                    showNewLabel: true,
                },
				{
					name: "ColourMatchV2",
					icon: "filter",
					label: "Technical Colour Match",
				},
				{
					name: "AdvancedColourMatchV2",
					icon: "filter",
					label: "Advanced Technical Colour Match",
				},
				// {
				// 	name: "exposure",
				// 	icon: "exposure",
				// 	label: "Exposure",
				// },
				{
					name: "ExposureV2",
					icon: "exposure",
					label: "Exposure",
				},
				// {
				// 	name: "contrast",
				// 	icon: "hdr_strong",
				// 	label: "Contrast",
				// },
				{
					name: "ContrastV2",
					icon: "hdr_strong",
					label: "Contrast",
				},
				{
					name: "Vibrance",
					icon: "opacity",
					iconClass: "material-symbols-outlined",
					label: "Vibrance",
				},
				{
					name: "hueSaturation",
					icon: "invert_colors",
					label: "Hue/Saturation",
				},
				{
					name: "whiteBalance",
					icon: "wb_sunny",
					label: "White Balance",
				},
				{
					name: "shadowHighlightsRecovery",
					icon: "hdr_weak",
					label: "Shadow/Highlight Recovery",
				},
				{
					name: "smartCurves",
					icon: "timeline",
					label: "Smart Curves",
				},
				{
					name: "HSL",
					icon: "tune",
					label: "HSL",
				},
				{
					name: "blackAndWhite",
					icon: "filter_b_and_w",
					label: "Black and White",
				},
				{
					name: "CustomLutV2",
					icon: "image_aspect_ratio",
					label: "Custom 3D LUT",
					showImprovedLabel: true,
				},
				{
					name: "GamutCompress",
					icon: "format_color_fill",
					iconClass: "material-symbols-outlined",
					label: "ACES Gamut Compression",
				},
				{
					name: "LUTcontrols",
					category: "Gamut Limit",
					icon: "opacity",
					iconClass: "material-symbols-outlined",
					label: "Gamut Limit",
					LUTbased: true,
				},
			],
		},
		{
			type: "creative",
			label: "Creative Blocks",
			controls: [
				{
					name: "LUTcontrols",
					category: "Cine Looks",
					icon: "local_movies",
					label: "Cine Looks",
					LUTbased: true,
				},
				{
					name: "LUTcontrols",
					category: "Print Film Emulation",
					icon: "camera_roll",
					label: "Print Film Emulation",
					LUTbased: true,
				},
				{
					name: "LUTcontrols",
					category: "Filmic Curve Response",
					icon: "timeline",
					label: "Filmic Curve Response",
					LUTbased: true,
				},
				{
					name: "colourDensity",
					category: "Colour Density",
					icon: "gradient",
					label: "Colour Density",
					LUTbased: true,
				},
				{
					name: "LUTcontrols",
					category: "Shadow Tint",
					icon: "lens",
					label: "Shadow Tint",
					LUTbased: true,
				},
				{
					name: "LUTcontrols",
					category: "Highlight Tint",
					icon: "panorama_fish_eye",
					label: "Highlight Tint",
					LUTbased: true,
				},
				{
					name: "LUTcontrols",
					category: "Neutral Tint",
					icon: "trip_origin",
					label: "Neutral Tint",
					LUTbased: true,
				},
				{
					name: "LUTcontrols",
					category: "Skin Tone",
					icon: "face",
					label: "Skin Tone",
					LUTbased: true,
				},
				{
					name: "LUTcontrols",
					category: "Blue Tone",
					icon: "waves",
					label: "Blue Tone",
					LUTbased: true,
				},
				{
					name: "LUTcontrols",
					category: "Green Tone",
					icon: "filter_vintage",
					label: "Green Tone",
					LUTbased: true,
				},
				{
					name: "LUTcontrols",
					category: "Yellow Tone",
					icon: "flare",
					label: "Yellow Tone",
					LUTbased: true,
				},
				{
					name: "smartWarmth",
					category: "Smart Warmth",
					icon: "brightness_5",
					label: "Smart Warmth",
					LUTbased: true,
				},
				{
					name: "tealAndOrange",
					category: "Teal and Orange",
					icon: "videocam",
					label: "Teal and Orange",
					LUTbased: true,
				},
				{
					name: "technicolor3StripProcess",
					category: "Technicolor 3 Strip",
					icon: "filter_frames",
					label: "Technicolor 3-Strip Process",
					LUTbased: true,
				},
				{
					name: "LUTcontrols",
					category: "Illuminant",
					icon: "looks",
					label: "Illuminant",
					LUTbased: true,
				},
				{
					name: "midtoneTexture",
					icon: "grain",
					label: "Texture",
				},
			],
		},
		{
			type: "magic-mode",
			label: "Magic Mode Tools",
			controls: [
				{
					name: "AIExposure",
					icon: "exposure",
					label: "AI Exposure",
				},
				{
					name: "AIContrast",
					icon: "hdr_strong",
					label: "AI Contrast",
				},
				{
					name: "AIWhiteBalance",
					icon: "wb_sunny",
					label: "AI White Balance",
				},
				{
					name: "LUTcontrols",
					category: "Teal and Orange",
					icon: "videocam",
					label: "Teal and Orange",
					LUTbased: true,
				},
				{
					name: "LUTcontrols",
					category: "Smart Warmth",
					icon: "brightness_5",
					label: "Smart Warmth",
					LUTbased: true,
				},
			],
		},
		{
			type: "legacy-magic-mode",
			label: "Legacy Magic Mode Tools",
			controls: [
				{
					name: "LegacyMagicMode",
					label: "Legacy Magic Mode",
					icon: "",
					iconClass: "fas fa-magic"
				},
				{
					name: "LUTcontrols",
					category: "Exposure",
					icon: "exposure",
					label: "Legacy Exposure",
					LUTbased: true,
				},
				{
					name: "LUTcontrols",
					category: "White Balance",
					icon: "wb_sunny",
					label: "Legacy White Balance",
					LUTbased: true,
				},
				{
					name: "LUTcontrols",
					category: "Contrast",
					icon: "hdr_strong",
					label: "Legacy Contrast",
					LUTbased: true,
				},
			],
		},
	],
	magicModeBlocks: [
		{
			name: "LUTcontrols",
			category: "Exposure",
			icon: "exposure",
			label: "Exposure",
		},
		{
			name: "LUTcontrols",
			category: "White Balance",
			icon: "wb_sunny",
			label: "White Balance",
		},
		{
			name: "LUTcontrols",
			category: "Contrast",
			icon: "hdr_strong",
			label: "Contrast",
		},
		{
			name: "LUTcontrols",
			category: "Cine Looks",
			icon: "local_movies",
			label: "Cine Looks",
		},
		{
			name: "LUTcontrols",
			category: "Print Film Emulation",
			icon: "camera_roll",
			label: "Print Film Emulation",
		},
		{
			name: "LUTcontrols",
			category: "Skin Tone",
			icon: "face",
			label: "Skin Tone",
		},
		{
			name: "LUTcontrols",
			category: "Shadow Tint",
			icon: "lens",
			label: "Shadow Tint",
		},
		{
			name: "LUTcontrols",
			category: "Highlight Tint",
			icon: "panorama_fish_eye",
			label: "Highlight Tint",
		},
		{
			name: "LUTcontrols",
			category: "Blue Tone",
			icon: "waves",
			label: "Blue Tone",
		},
		{
			name: "LUTcontrols",
			category: "Green Tone",
			icon: "filter_vintage",
			label: "Green Tone",
		},
		{
			name: "LUTcontrols",
			category: "Yellow Tone",
			icon: "flare",
			label: "Yellow Tone",
		},
		{
			name: "LUTcontrols",
			category: "Smart Warmth",
			icon: "brightness_5",
			label: "Smart Warmth",
		},
	],
	AIMagicModeBlocks: [
		{
			name: "AIControl",
			category: "AI Exposure",
			icon: "exposure",
			label: "AI Exposure",
		},
		{
			name: "AIControl",
			category: "AI Contrast",
			icon: "hdr_strong",
			label: "AI Contrast",
		},
		{
			name: "AIControl",
			category: "AI White Balance",
			icon: "wb_sunny",
			label: "AI White Balance",
		},
		{
			name: "LUTcontrols",
			category: "Film Grade",
			icon: "local_movies",
			label: "Film Grade",
		},
		{
			name: "LUTcontrols",
			category: "Skin Tone",
			icon: "face",
			label: "Skin Tone",
		},
		{
			name: "LUTcontrols",
			category: "Shadow Tint",
			icon: "lens",
			label: "Shadow Tint",
		},
		{
			name: "LUTcontrols",
			category: "Highlight Tint",
			icon: "panorama_fish_eye",
			label: "Highlight Tint",
		},
		{
			name: "LUTcontrols",
			category: "Blue Tone",
			icon: "waves",
			label: "Blue Tone",
		},
		{
			name: "LUTcontrols",
			category: "Green Tone",
			icon: "filter_vintage",
			label: "Green Tone",
		},
		{
			name: "LUTcontrols",
			category: "Yellow Tone",
			icon: "flare",
			label: "Yellow Tone",
		},
		{
			name: "LUTcontrols",
			category: "Smart Warmth",
			icon: "brightness_5",
			label: "Smart Warmth",
		},
	],
};

// Currently we have following order of passes:
// Render pass (fixed)
// IDT pass (fixed)
// User selected blocks (dynamic)
// ODT pass (fixed)
config.startFixedPasses = 3; // number of fixed passes going from start
config.endFixedPasses = 1; // number of fixed passed going from end

// Color Wheel options
config.colorWheelOptions = {
	width: 100,
	layout: [
		{
			component: iro.ui.Wheel,
			options: {
				padding: -2,
				handleRadius: 4,
			},
		},
	],
};

// GET parametes for testing
// if (config.queryDict) {
// 	var queryDict = {};
// 	location.search
// 		.substr(1)
// 		.split("&")
// 		.forEach(function(item) {
// 			queryDict[item.split("=")[0]] = item.split("=")[1];
// 		});
// }

export default config;
